// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2bjW_","icon":"SortAdornment_icon__54gqt","up":"SortAdornment_up__ug4Bg","down":"SortAdornment_down__9eaQv","active":"SortAdornment_active__30Cif"};